module.exports = __webpack_public_path__ + "static/www/img/course_tensorflow.dd05c11.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/course/course_tensorflow.jpg
// module id = 384
// module chunks = 1